import { useJsApiLoader } from '@react-google-maps/api';

// `marker` is required for AdvancedMarkerElement (replaces deprecated Marker).
// `drawing` is required for the GeofenceEditor's DrawingManager.
// `places` is required for Google Places Autocomplete search.
// `geometry` is required for the Phase 78aj route preview modal to
// decode polylines returned by the optimize-stops endpoint.
// `routes` is loaded on-demand via importLibrary() inside RoutePolyline.
const LIBRARIES = ['drawing', 'marker', 'places', 'geometry'];

// A Cloud-vector-styling Map ID is REQUIRED to render AdvancedMarker.
// `DEMO_MAP_ID` is Google's public sample ID — fine for unstyled maps.
// If the project later registers a Cloud Map ID for custom styling,
// override via REACT_APP_GOOGLE_MAPS_MAP_ID.
export const GOOGLE_MAPS_MAP_ID =
  process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || 'DEMO_MAP_ID';

export function useGoogleMaps() {
  return useJsApiLoader({
    id: 'carloo-maps',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    libraries: LIBRARIES,
  });
}
